import { getContextFromUrl } from 'config/Config';

export const properties  = {
    PDF_ICON: `${getContextFromUrl()}` + 'pdfGrisVerde.svg',
    IMAGE_ICON: `${getContextFromUrl()}` + 'imgAzul.svg',
    VIDEO_ICON: `${getContextFromUrl()}` + 'videoRojo.svg',
    TEXT_BOTON: 'MOSTRAR PDF'
  }